module.exports = __webpack_public_path__ + "img/radar1.0a00d839.gif";